import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { TourProvider } from '@reactour/tour'
import { Admin } from 'components/Admin'
import { isNil } from 'lodash/fp'

const App: React.FC = () => {
  return (
    <BrowserRouter>
      {!isNil(process.env['TOUR']) ? (
        <TourProvider steps={[]}>
          <Routes>
            <Route path="/menu/:partner/" element={<Admin />} />
            <Route path="/*" element={<Admin />} />
            <Route path="/" element={<Admin />} />
          </Routes>
        </TourProvider>
      ) : (
        <Routes>
          <Route path="/menu/:partner/" element={<Admin />} />
          <Route path="/admin/:partner" element={<Admin admin />} />
          <Route path="/*" element={<Admin />} />
          <Route path="/" element={<Admin />} />
        </Routes>
      )}
    </BrowserRouter>
  )
}

export default App
